"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTZ = exports.supportedTZs = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
// const { supportedTZs, defaultTZ }= config.app
// export { supportedTZs, defaultTZ }
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
exports.supportedTZs = (config_1.default.apps?.supportedTZs ?? iotv_v3_types_1.allSupportedTZs);
exports.defaultTZ = 'NZ';
